import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { slotDefinition } from "slotworks/model/slot-definition";

declare const __VERSION__: string;
declare const __GAMENAME__: string;

class TranslationKeyReplacer {

    private stringValueMap: Map<string, () => number | string>;

    public constructor() {
        this.stringValueMap = new Map();
        this.stringValueMap.set("totalstake", () => this.returnTotalStake());
        this.stringValueMap.set("totallines", () => this.returnTotalLines());
        this.stringValueMap.set("totalwin", () => this.returnTotalWin());
        this.stringValueMap.set("version", () => this.returnVersionNumber());
        this.stringValueMap.set("gamename", () => this.returnGameName());
    }

    public lookup(toLookup: string) {
        return this.stringValueMap.has(toLookup);
    }

    public get(toGet: string): string | number {
        return this.stringValueMap.get(toGet)();
    }

    private returnTotalStake(): string {
        return Services.currency.format(Services.bet.getTotalStake());
    }

    private returnTotalLines(): number {
        return slotDefinition.lines.values.length;
    }

    private returnTotalWin(): string {
        if (gameState.getCurrentGame().hasRecords()) {
            return Services.currency.format(gameState.getCurrentGame().getTotalWin());
        }
    }

    private returnVersionNumber() {
        return __VERSION__;
    }

    private returnGameName() {
        return __GAMENAME__;
    }
}

export const translationKeyReplacer = new TranslationKeyReplacer();
